import React from "react";
import { getLoadingTranslation } from "../lib/localizedText";

const FormError = ({ locale = "GB" }) => {
  const { errorTitle, errorMessage } = getLoadingTranslation(locale);

  return (
    <div className="message__container error-message">
      <div className="message__container--text">
        <h3 className="message__container--error">{errorTitle}</h3>
        <p className="message__container--error">{errorMessage}</p>
      </div>
    </div>
  );
};

export default FormError;
